import styled from 'styled-components'

const Style = {
	Main: styled.main`
		flex-grow: 1;
		background-color: ${({theme}) => theme.color.grey1};
		padding: 10px;
		height: calc(100dvh - 80px);
		overflow-y: auto;

		@media (min-width: ${({theme}) => theme.breakpoints.mobile}) {
			padding: 40px;
		}
	`,
}

export default Style
